import React from "react";
import { UserSelect } from "../../../components/common/form/UserSelect";
import { User } from "../../../types";

interface ParticipantFilterProps {
  seasonUsers: User[];
  selectedUserId: string;
  onChange: (value: string) => void;
}

// Filtro del calendario per singolo partecipante/iscritto.
export const ParticipantFilter: React.FC<ParticipantFilterProps> = ({
  seasonUsers,
  selectedUserId,
  onChange,
}) => (
  <section className="rounded border border-gray-300 bg-white p-4 shadow-sm">
    <div className="grid gap-4 md:grid-cols-[minmax(0,1.2fr)_auto] md:items-end">
      <label className="space-y-1">
        <span className="block text-sm font-medium text-gray-700">Filtra per partecipante</span>
        <UserSelect
          users={seasonUsers}
          value={selectedUserId === "" ? null : Number(selectedUserId)}
          onChange={(userId) => onChange(userId == null ? "" : String(userId))}
          placeholder="Tutti gli iscritti"
          emptyOptionLabel="Tutti gli iscritti"
          className="text-sm text-gray-900"
        />
      </label>
    </div>
  </section>
);
